import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CTAButton } from '@/types/ui/public-page';

interface PublicFinalCTAProps {
  backgroundImage: string;
  gradientOverlay: string;
  title: string;
  description: string;
  primaryButton: CTAButton;
  secondaryButton?: CTAButton;
  disclaimer?: string;
}

const PublicFinalCTA = ({
  backgroundImage,
  gradientOverlay,
  title,
  description,
  primaryButton,
  secondaryButton,
  disclaimer
}: PublicFinalCTAProps) => {
  return (
    <section className={`relative py-24 md:py-32 ${gradientOverlay} text-white overflow-hidden`}>
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
        <div className={`absolute inset-0 ${gradientOverlay}`}></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
          {title}
        </h2>

        <p className="text-xl text-gray-100 mb-10 max-w-2xl mx-auto">
          {description}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={primaryButton.onClick}
            disabled={primaryButton.disabled}
            size="lg"
            className="bg-white text-gray-900 hover:bg-gray-100 font-semibold shadow-xl"
          >
            {primaryButton.text}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>

          {secondaryButton && (
            <Button
              variant="outline"
              size="lg"
              className="bg-white/10 text-white border-2 border-white hover:bg-white/20 font-semibold shadow-xl"
              onClick={secondaryButton.onClick}
            >
              {secondaryButton.text}
            </Button>
          )}
        </div>

        {disclaimer && (
          <p className="mt-8 text-sm text-gray-200">
            {disclaimer}
          </p>
        )}
      </div>
    </section>
  );
};

export default PublicFinalCTA;